import React, { useState } from "react"
import styled from "styled-components"
import { H1 } from "../Styles/TextStyles"

function MockupWelcome() {
  const [show, isShowing] = useState(false)
  return (
    <Wrapper>
      <ContentWrapper>
        <Burst
          onMouseEnter={() => isShowing(true)}
          onMouseLeave={() => isShowing(false)}
        >
          <Image className="mainLogo" src="../PM/Logo-1.png" isShowing={show} />
          <div className="box1" />
          <div className="box2" />
          <div className="box3" />
          <div className="box4" />
          <div className="box5" />
          <Text className="text1">BE</Text>
          <Text className="text2">THE</Text>
          <Text className="text3">PROFICIENT</Text>
          <Text className="text4">OUR MISSION</Text>
        </Burst>
      </ContentWrapper>
    </Wrapper>
  )
}

export default MockupWelcome

const Image = styled.img`
  position: relative;
  width: 200px;
  height: 200px;
  z-index: 1;
`
const Text = styled(H1)`
  color: #ffffff;
`

const Wrapper = styled.div`
  position: relative;
  max-width: 1234px;
  margin: 0 auto;
  padding: 200px 30px;
  top: -100px;
`
const ContentWrapper = styled.div`
  max-width: 1234px;
  margin: 0 auto;
  padding: 200px 30px;
`

const Burst = styled.div`
  :hover {
    .box1 {
      filter: saturate(180%) brightness(100%);
    }
    .box2 {
      right: 58.05px;
      top: 335px;
    }
    .box3 {
      right: 757.86px;
      top: 158px;
    }
    .box4 {
      right: 727px;
      top: 567px;
    }
    .box5 {
      right: 773.08px;
      top: 531px;
    }
    .mainLogo {
      opacity: 1;
    }
    .text1 {
      opacity: 0;
      top: -520px;
    }
    .text2 {
      opacity: 0;
      right: -1060px;
    }
    .text3 {
      opacity: 0;
      top: 1000px;
    }
    .text4 {
      opacity: 1;
      top: -650px;
    }
  }

  .text1 {
    font-size: 90px;
    position: relative;
    z-index: 4;
    top: -220px;
    right: -300px;
    width: 183px;
    height: 120.18px;
    transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  .text2 {
    font-size: 50px;
    position: relative;
    top: -270px;
    right: -760px;
    z-index: 4;
    transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  .text3 {
    font-size: 65px;
    position: relative;
    width: 412.14px;
    height: 273.84px;
    right: -627.86px;
    top: -80px;
    z-index: 4;
    padding: 10px;
    text-align: center;
    transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  .text4 {
    font-size: 75px;
    position: relative;
    width: 412.14px;
    height: 273.84px;
    right: -50.86px;
    top: -050px;
    z-index: 4;
    padding: 10px;
    text-align: left;
    transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);
    opacity: 0;
  }
  .mainLogo {
    position: absolute;
    right: 509.96px;
    top: 326px;
    z-index: 2;
    opacity: 0;
    transition: cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  .box1 {
    position: absolute;
    width: 701.04px;
    height: 427.88px;
    right: 269.96px;
    top: 226px;

    background-color: #5de6de;
    background-image: linear-gradient(315deg, #5de6de 0%, #b58ecc 74%);
    border: 0.342305px solid rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(27.3844px);
    /* Note: backdrop-filter has minimal browser support */
    transition: cubic-bezier(0.47, 0, 0.745, 0.715);
    border-radius: 6.8461px;
    filter: brightness(150%) saturate(120%);
    z-index: 1;
  }
  .box2 {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 13.6922px;

    position: absolute;
    width: 398.95px;
    height: 273.84px;
    right: 618.05px;
    top: 355px;

    background: linear-gradient(
      153.51deg,
      #ff2020 8.86%,
      #ef325f 43.93%,
      #59248a 80.22%
    );
    border: 0.342305px solid rgba(255, 255, 255, 0.2);
    box-sizing: border-box;
    backdrop-filter: blur(27.3844px);
    transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);

    border-radius: 13.6922px;
    :hover {
      filter: brightness(150%) saturate(120%);
    }
    z-index: 3;
  }
  .box3 {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 13.6922px;

    position: absolute;
    width: 412.14px;
    height: 273.84px;
    right: 137.86px;
    top: 378px;

    background: linear-gradient(200.44deg, #4316db 13.57%, #9076e7 98.38%);
    mix-blend-mode: normal;
    background-blend-mode: overlay, overlay, normal;
    border: 0.342305px solid rgba(255, 255, 255, 0.2);
    box-sizing: border-box;
    backdrop-filter: blur(27.3844px);
    transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);

    border-radius: 13.6922px;
    :hover {
      filter: brightness(150%) saturate(120%);
    }
    z-index: 3;
  }
  .box4 {
    position: absolute;
    width: 183px;
    height: 120.18px;
    right: 727px;
    top: 167px;

    background: radial-gradient(
      218.51% 281.09% at 100% 100%,
      rgba(253, 63, 51, 0.6) 0%,
      rgba(76, 0, 200, 0.6) 45.83%,
      rgba(76, 0, 200, 0.6) 100%
    );
    border: 0.273134px solid rgba(255, 255, 255, 0.3);
    box-sizing: border-box;
    box-shadow: 0px 16.3881px 32.7761px rgba(99, 30, 187, 0.5);
    backdrop-filter: blur(21.8507px);
    transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);

    border-radius: 13.6922px;
    :hover {
      filter: brightness(150%) saturate(120%);
    }
    z-index: 3;
  }
  .box5 {
    position: absolute;
    width: 182.94px;
    height: 120.14px;
    right: 273.08px;
    top: 211px;

    background: linear-gradient(180deg, #ff5252 0%, #ff72b6 100%);
    mix-blend-mode: normal;
    border: 0.27304px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0px 8.19119px 16.3824px rgba(0, 0, 0, 0.1),
      0px 16.3824px 32.7648px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(21.8432px);
    transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);

    border-radius: 13.6922px;
    :hover {
      filter: brightness(150%) saturate(120%);
    }
    z-index: 3;
    transform: matrix(1, 0, -0.01, 1, 0, 0);
  }
`
